'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _chemist = require('chemist');

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Logo = (_dec = (0, _chemist.configurable)(), _dec2 = (0, _reactCssModules2.default)(_style2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Logo, _React$Component);

  function Logo() {
    (0, _classCallCheck3.default)(this, Logo);
    return (0, _possibleConstructorReturn3.default)(this, (Logo.__proto__ || (0, _getPrototypeOf2.default)(Logo)).apply(this, arguments));
  }

  (0, _createClass3.default)(Logo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          siteCode = _props.siteCode,
          config = _props.config;
      var logoStyle = config.store.logoStyle;


      var logo = require('./assets/' + config.theme + '/' + siteCode + '.png');

      var style = 'logo-' + logoStyle;

      return _react2.default.createElement('img', { styleName: style, srcSet: logo, alt: this.props.alt });
    }
  }]);
  return Logo;
}(_react2.default.Component), _class2.propTypes = {
  alt: _react.PropTypes.string.isRequired,
  siteCode: _react.PropTypes.string
}, _class2.defaultProps = {
  siteCode: 'eukdlx'
}, _temp)) || _class) || _class);
exports.default = Logo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/Logo/index.js
// module id = 592
// module chunks = 0